export default __webpack_public_path__ + "8aab4d57aeb7e6e11bdef253c1a0f422.png";